/* Area cliente American Uncle: tab della dashboard, "Riordina", reimpostazione password da loggati */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Tab della pagina /account (#ordini, #profilo, #password).
     Da computer senza sezione nell'URL si apre Ordini; da telefono si vede l'elenco delle voci (data-view="home")
     e toccando una voce si apre solo quella sezione (data-view="section"). Cambiare sezione non fa scorrere la pagina,
     e il tasto indietro del browser torna alla vista precedente. */
  function initTabs() {
    var wrap = document.querySelector('[data-au-tabs]');
    if (!wrap) return;
    var dash = document.querySelector('[data-au-dash]');
    var panels = wrap.querySelectorAll('[data-au-panel]');
    var links = document.querySelectorAll('[data-au-tab]');

    function isPanel(name) {
      var found = false;
      panels.forEach(function (p) { if (p.getAttribute('data-au-panel') === name) found = true; });
      return found;
    }

    function show(name) {
      var hasSection = isPanel(name);
      if (dash) dash.setAttribute('data-view', hasSection ? 'section' : 'home');
      if (!hasSection) name = panels[0].getAttribute('data-au-panel');
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-au-panel') !== name; });
      links.forEach(function (a) {
        if (a.getAttribute('data-au-tab') === name) a.setAttribute('aria-current', 'page');
        else a.removeAttribute('aria-current');
      });
    }

    function go(hash) {
      // Tornando all'elenco si toglie anche ?page= della paginazione ordini
      var url = hash ? location.pathname + location.search + '#' + hash : location.pathname;
      if (url !== location.pathname + location.search + location.hash) history.pushState(null, '', url);
      show(hash);
      if (window.matchMedia('(max-width: 860px)').matches) window.scrollTo(0, 0);
    }

    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        go(a.getAttribute('data-au-tab'));
      });
    });
    var home = wrap.querySelector('[data-au-home]');
    if (home) home.addEventListener('click', function (e) { e.preventDefault(); go(''); });

    // Paginazione degli ordini (?page=N): resta nella sezione Ordini, anche da telefono
    var ordersPanel = wrap.querySelector('[data-au-panel="ordini"]');
    if (ordersPanel) {
      ordersPanel.querySelectorAll('a[href*="page="]').forEach(function (a) {
        a.setAttribute('href', a.getAttribute('href').split('#')[0] + '#ordini');
      });
    }
    function current() {
      var hash = location.hash.slice(1);
      if (!hash && /[?&]page=/.test(location.search)) hash = 'ordini';
      return hash;
    }

    window.addEventListener('popstate', function () { show(current()); });
    window.addEventListener('hashchange', function () { show(current()); });
    show(current());
  }

  /* Riordina: aggiunge al carrello gli articoli ancora disponibili.
     Con l'app YMQ Cart Drawer attiva il drawer si apre da solo: YMQ intercetta le fetch verso cart/add
     (il parametro ymqcartopen=true glielo conferma); senza YMQ si va alla pagina carrello. */
  function ymqActive() {
    return !!(window.ymqCart || document.getElementById('ymq-cart-app'));
  }

  function postItems(items) {
    return fetch(root + 'cart/add.js?ymqcartopen=true', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    });
  }

  function addItems(items) {
    return postItems(items).then(function (res) {
      if (res.ok) return items.length;
      // Se un articolo non è più acquistabile nella quantità richiesta, riprova uno alla volta
      var added = 0;
      return items.reduce(function (chain, item) {
        return chain.then(function () {
          return postItems([item]).then(function (r) { if (r.ok) added++; }).catch(function () {});
        });
      }, Promise.resolve()).then(function () { return added; });
    });
  }

  function initReorder() {
    document.querySelectorAll('[data-au-reorder]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var msg = btn.closest('[data-au-reorder-wrap]');
        msg = msg && msg.querySelector('[data-au-reorder-msg]');
        var items;
        try { items = JSON.parse(btn.getAttribute('data-items') || '[]'); } catch (e) { items = []; }

        function say(text, isError) {
          if (!msg) return;
          msg.textContent = text;
          msg.hidden = false;
          msg.classList.toggle('is-error', !!isError);
        }

        if (!items.length) { say(btn.getAttribute('data-msg-none'), true); return; }

        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        addItems(items).then(function (added) {
          if (added > 0) {
            if (!ymqActive()) window.location.href = btn.getAttribute('data-cart-url') || root + 'cart';
          } else {
            say(btn.getAttribute('data-msg-none'), true);
          }
        }).catch(function () {
          say(btn.getAttribute('data-msg-error'), true);
        }).finally(function () {
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
        });
      });
    });
  }

  /* Reimposta password da loggati: invio classico del form (serve alla protezione anti-bot di Shopify,
     che rifiuta gli invii via fetch). Shopify poi riporta il cliente sull'area account:
     un segnale in sessionStorage fa comparire la conferma nel tab Password. */
  var RECOVER_KEY = 'au_recover_sent';

  function initRecover() {
    var box = document.querySelector('[data-au-recover]');
    if (!box) return;
    var form = box.querySelector('form');
    var ok = box.querySelector('[data-au-recover-ok]');

    try {
      var sent = parseInt(sessionStorage.getItem(RECOVER_KEY) || '0', 10);
      // Conferma solo al ritorno dall'invio (referrer = area account), non a visite successive
      var fromAccount = document.referrer.indexOf(location.origin + '/account') === 0;
      if (sent && !fromAccount) sessionStorage.removeItem(RECOVER_KEY);
      if (sent && fromAccount && Date.now() - sent < 10 * 60 * 1000) {
        sessionStorage.removeItem(RECOVER_KEY);
        ok.hidden = false;
        form.hidden = true;
        if (!location.hash) history.replaceState(null, '', '#password');
      }
    } catch (e) {}

    var btn = form.querySelector('button[type="submit"]');
    var slow = box.querySelector('[data-au-recover-slow]');
    var label = btn.textContent;
    var slowTimer;

    // Aggancia l'hCaptcha di Shopify quando il pannello è visibile: lo script "captcha-bootstrap" di Shopify
    // lega il form al primo focusin su un suo elemento.
    function bindCaptcha() {
      if (box.hidden || form.getAttribute('data-hcaptcha-bound')) return;
      btn.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
    }
    new MutationObserver(bindCaptcha).observe(box, { attributes: true, attributeFilter: ['hidden'] });
    btn.addEventListener('pointerdown', bindCaptcha);
    setTimeout(bindCaptcha, 0);

    form.addEventListener('submit', function () {
      btn.textContent = btn.getAttribute('data-sending-label') || label;
      btn.setAttribute('aria-busy', 'true');
      slow.hidden = true;
      clearTimeout(slowTimer);
      // Se dopo qualche secondo siamo ancora qui, l'invio è fermo (verifica anti-spam da completare o troppi tentativi)
      slowTimer = setTimeout(function () {
        btn.textContent = label;
        btn.removeAttribute('aria-busy');
        slow.hidden = false;
      }, 8000);
    });

    // Conferma solo per un invio vero: Shopify inserisce il token hCaptcha subito prima di inviare il form.
    // Un semplice aggiornamento della pagina non deve far comparire "Fatto".
    window.addEventListener('pagehide', function () {
      var token = form.elements['h-captcha-response'];
      if (token && token.value) {
        try { sessionStorage.setItem(RECOVER_KEY, String(Date.now())); } catch (e) {}
      }
    });
  }

  /* Pagina di login: titolo coerente col form aperto (accesso / password dimenticata) e,
     al ritorno dalla richiesta di reset fatta dall'area cliente, conferma al posto del form di reset. */
  function initLoginPage() {
    var hero = document.querySelector('[data-au-login-hero]');
    var recover = document.getElementById('RecoverPasswordForm');
    var login = document.getElementById('CustomerLoginForm');
    if (!hero || !recover || !login) return;
    var title = hero.querySelector('.au-acc__title');
    var sub = hero.querySelector('.au-acc__sub');
    var loginTitle = title.textContent;
    var loginSub = sub.textContent;

    function sync() {
      var isRecover = !recover.classList.contains('hide');
      title.textContent = isRecover ? hero.getAttribute('data-recover-title') : loginTitle;
      sub.textContent = isRecover ? hero.getAttribute('data-recover-sub') : loginSub;
    }
    new MutationObserver(sync).observe(recover, { attributes: true, attributeFilter: ['class'] });

    try {
      var sent = parseInt(sessionStorage.getItem(RECOVER_KEY) || '0', 10);
      if (sent && Date.now() - sent < 10 * 60 * 1000) {
        sessionStorage.removeItem(RECOVER_KEY);
        // section-main-login.js riapre il form di reset (hash #recover): lo richiudiamo dopo di lui
        setTimeout(function () {
          recover.classList.add('hide');
          login.classList.remove('hide');
          var ok = document.getElementById('ResetSuccess');
          if (ok) ok.classList.remove('hide');
          if (location.hash === '#recover') history.replaceState(null, '', location.pathname + location.search);
          sync();
        }, 300);
      }
    } catch (e) {}
    sync();
  }

  /* Rubrica indirizzi: "Elimina" mostra la conferma dentro la card (niente confirm() del browser) */
  function initAddressDelete() {
    document.querySelectorAll('[data-au-delete]').forEach(function (btn) {
      var card = btn.closest('.au-address');
      var actions = card.querySelector('[data-au-address-actions]');
      var confirmBox = card.querySelector('[data-au-delete-confirm]');
      btn.addEventListener('click', function () {
        actions.hidden = true;
        confirmBox.hidden = false;
        confirmBox.querySelector('button[type="submit"]').focus();
      });
      confirmBox.querySelector('[data-au-delete-cancel]').addEventListener('click', function () {
        confirmBox.hidden = true;
        actions.hidden = false;
        btn.focus();
      });
    });
  }

  function init() {
    initAddressDelete();
    initLoginPage();
    initRecover();
    initTabs();
    initReorder();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
